import { ISubAsset } from '@interface/marketplace/SubAsset';
import { IAction } from '@/interface/IAction';
import { IPurchaseResult } from '@/interface/marketplace/PurchaseResult';

export const actionType = Object.freeze({

    GET_SUBSCRIBED_ASSET_TYPE: 'marketplace.get-subscribed-asset-list',
    GET_LIVE_RECEIVABLE_LIST: 'marketplace.get-live-receivable-list',


    SET_LIVE_RECEIVABLE_LIST: 'marketplace.set-live-receivable-list',
    SET_SUBSCRIBED_ASSET_TYPE: 'marketplace.set-subscribed-asset-list',

    GET_PURCHASE_SUB_ASSETS: 'marketplace.get-purchase-sub-asset',
    SET_PURCHASE_SUB_ASSETS: 'marketplace.set-purchase-sub-asset',

    SET_BUY_NOW_MODAL_INITIALIZED: 'marketplace.set-buy-now-modal-initialized',

    RESET: 'marketplace.reset',
    CLOSE_BUY_NOW_MODAL: 'marketplace.reset-buy-now-modal',

    SET_RECEIVABLE_DETAIL: 'marketplace.set-receivable-detail',

    INIT_RECEIVABLE_DETAIL_PAGE: 'marketplace.init-receivable-detail-page',
    INIT_RECEIVABLE_SELLER_STATISTICS_PAGE: 'marketplace.init-receivable-seller-statistic-page',

    SET_SELLER_KEY_FIGURE: 'marketplace.set-key-figure',
    SET_SELLER_STATS: 'marketplace.set-seller-stats',
    SET_SELLER_LIVE_ASSET: 'marketplace.set-seller-live-asset',
    SET_SELLER_PREVIOUS_ASSET: 'marketplace.set-seller-previous-asset',

    SET_PURCHASE_ASSETS: 'marketplace.purchase-assets',
    SET_PURCHASE_ASSETS_CB: 'marketplace.purchase-assets-callback',
    PURCHASE_SUB_ASSET_WITH_CHECKING: 'marketplace.purchase-asset-with-checking',

    GET_PRE_SIGNED_SELLER_REPORT_URL: 'marketplace.get-pre-signed-seller-report-url',
    SET_PRE_SIGNED_SELLER_REPORT_URL: 'marketplace.set-pre-signed-seller-report-url',

    GET_CREDIT_ENHANCEMENT_MAPPING: 'marketplace.get-credit-enhancement-mapping',
    SET_CREDIT_ENHANCEMENT_MAPPING: 'marketplace.set-credit-enhancement-mapping',
});

export function getSubAssetList(assetId: string): IAction {
    return {
        type: actionType.GET_PURCHASE_SUB_ASSETS,
        payload: { assetId }
    }
}

export function setAvailableSubAssetList(assetId: string, subAssetList: ISubAsset[]): IAction {
    return {
        type: actionType.SET_PURCHASE_SUB_ASSETS,
        payload: { assetId, subAssetList }
    }
}

export function getSubscribedAssetType(): IAction {
    return {
        type: actionType.GET_SUBSCRIBED_ASSET_TYPE
    }
}

export function getLiveReceivableList(): IAction {
    return {
        type: actionType.GET_LIVE_RECEIVABLE_LIST,
        payload: {}
    }
}

export function setSubscribedAsset(subscribedList: string[]): IAction {
    return {
        type: actionType.SET_SUBSCRIBED_ASSET_TYPE,
        payload: subscribedList
    }
}

export function setLiveReceivableList(liveReceivableList: string[]): IAction {
    return {
        type: actionType.SET_LIVE_RECEIVABLE_LIST,
        payload: liveReceivableList
    }
}

export function closeBuyNowModal(): IAction {
    return { type: actionType.CLOSE_BUY_NOW_MODAL }
}

export function resetMarketplaceStore(): IAction {
    return { type: actionType.RESET };
}

export function setReceivableDetail(receivableDetail): IAction {
    return {
        type: actionType.SET_RECEIVABLE_DETAIL,
        payload: receivableDetail
    }
}

export function initReceivableDetailPage(receivableId: string): IAction {
    return {
        type: actionType.INIT_RECEIVABLE_DETAIL_PAGE,
        payload: { receivableId }
    }
}

export function initReceivableSellerStatisticsPage(receivableId: string): IAction {
    return {
        type: actionType.INIT_RECEIVABLE_SELLER_STATISTICS_PAGE,
        payload: { receivableId }
    }
}


export function setKeyFigure(assetId: string, keyFigure: any): IAction {
    return {
        type: actionType.SET_SELLER_KEY_FIGURE,
        payload: { assetId, keyFigure }
    }
}

export function setSellerStats(assetId: string, stats: any): IAction {
    return {
        type: actionType.SET_SELLER_STATS,
        payload: { assetId, stats }
    }
}

export function setSellerLiveAsset(sellerId: string, asset: any[]): IAction {
    return {
        type: actionType.SET_SELLER_LIVE_ASSET,
        payload: { sellerId, asset }
    }
}

export function setSellerPreviousAsset(sellerId: string, asset: any[]): IAction {
    return {
        type: actionType.SET_SELLER_PREVIOUS_ASSET,
        payload: { sellerId, asset }
    }
}

export function setPurchaseAsset(assetType: string, assetId: string, amount: number): IAction {
    return {
        type: actionType.SET_PURCHASE_ASSETS,
        payload: {
            assetType,
            assetId,
            amount
        }
    }
}

export function setPurchaseResult(purchaseResult: IPurchaseResult): IAction {
    return {
        type: actionType.SET_PURCHASE_ASSETS_CB,
        payload: purchaseResult
    }
}

export function getPreSignedSellerReportUrl(receivableId: string): IAction {
    return {
        type: actionType.GET_PRE_SIGNED_SELLER_REPORT_URL,
        payload: {
            receivableId
        }
    }
}

export function setPreSignedSellerReportUrl(url: string): IAction {
    return {
        type: actionType.SET_PRE_SIGNED_SELLER_REPORT_URL,
        payload: url
    }
}

export function purchaseSubAssetWithSellerChecking(assetType: string, assetId: string, amount: number) {
    return {
        type: actionType.PURCHASE_SUB_ASSET_WITH_CHECKING,
        payload: {
            assetType,
            assetId,
            amount
        }
    }
}

export function getCreditEnhancementMapping(): IAction {
    return {
        type: actionType.GET_CREDIT_ENHANCEMENT_MAPPING
    }
}

export function setCreditEnhancementMapping(creditEnhancementMap: Map<string, Object>): IAction {
    return {
        type: actionType.SET_CREDIT_ENHANCEMENT_MAPPING,
        payload: creditEnhancementMap
    }
}